import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Subtitle2 from '../../../../common/typographys/Subtitle2';
import Body2 from '../../../../common/typographys/Body2';
import CheckboxPicker from '../../../../common/forms/CheckboxPicker';
import EntryBox from '../../../pieces/EntryBox';
import isEmpty from '../../../../../utils/isEmpty';
import { getMeetingAvailablePool } from '../../../../../store/actions/meetingsActions';

const AddPointFromPool = ({ typologyId, selectedPointId, onSelect }) => {
  const dispatch = useDispatch();
  const pool = useSelector(state => state.meetings?.pool || {});
  const points = pool.points || [];
  const themes = pool.themes || [];

  useEffect(() => {
    if (typologyId) dispatch(getMeetingAvailablePool(typologyId));
  }, [dispatch, typologyId]);

  if (isEmpty(points) && isEmpty(themes)) {
    return <Body2 secondary>Não existem propostas/pontos disponíveis na pool.</Body2>;
  }

  return (
    <>
      {points.map(point => (
        <EntryBox key={point.id}>
          <CheckboxPicker
            label={point.identifier_code ? `${point.identifier_code} - ${point.name}` : point.name}
            checked={selectedPointId === point.id}
            onClick={e => {
              e.preventDefault();
              onSelect(point);
            }}
          />
        </EntryBox>
      ))}
      {themes.map(theme => (
        <React.Fragment key={theme.id}>
          <Subtitle2>{theme.name}</Subtitle2>
          {theme.points.map(point => (
            <EntryBox key={point.id}>
              <CheckboxPicker
                label={
                  point.identifier_code ? `${point.identifier_code} - ${point.name}` : point.name
                }
                checked={selectedPointId === point.id}
                onClick={e => {
                  e.preventDefault();
                  onSelect(point);
                }}
              />
            </EntryBox>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

AddPointFromPool.defaultProps = {
  typologyId: null,
  selectedPointId: null,
};

AddPointFromPool.propTypes = {
  typologyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedPointId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
};

export default React.memo(AddPointFromPool);